import { BaseType } from '../../../models/base/base-type';
import { FiduciaryEntityTypeEnum } from '../enums/fiduciary-entity-type.enum';

export class FiduciaryType extends BaseType {
  public declare id: FiduciaryEntityTypeEnum;
}
